<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.recipes') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right">
        <div
          v-if="!loading"
          class="action">
          <BaseActionDropdown
            v-if="hasRoleDelete"
            :icon="`fas fa-cog`"
            :text="$t('button.options')"
            :items="[
              {
                icon: 'fas fa-trash',
                iconClassName: 'text-danger',
                text: $t('button.delete'),
                textClassName: 'text-danger',
                value: 'delete',
              }
            ]"
            @onSelect="handleSelectOption"
          />
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <RecipeForm
        :form.sync="form"
        :warehouses="warehouses"
        :products="products"
        :isSubmitted="isSubmitted"
        :disabled="disabled || disabledForm"
        :defaultValues="defaultValues"
        :showActionButtons="hasRoleEdit"
        @onSubmit="handleSubmit"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
      <baseConfirmDeleteModal
        :show="modal.show"
        :loading="modal.loading"
        @onClose="handleCloseModal"
        @onCancel="handleCancleModal"
        @onSubmit="handleSumitModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import RecipeForm from '../../../combine/RecipeForm.vue'

export default {
  mixins: [discardFormMixin, userPermissionMixin],

  components: {
    RecipeForm,
  },

  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      defaultValues: {},
      form: null,
      modal: {
        show: false,
        loading: false,
      },
    }
  },

  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      warehouses: 'getWarehouses',
      products: 'getProducts',
      recipe: 'getRecipe',
    }),
    disabledForm () {
      return !this.hasRoleEdit
    },
  },

  async mounted () {
    await this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 6,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 4, [{
      'name': this.$route.query.name,
      'router': {
        'name': 'RecipeEdit',
        'query': {
          id: this.$route.query.id,
          name: this.$route.query.name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 4,
      submenuAtIdx: 2,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, ['clearProducts'])
  },

  methods: {
    async fetchData () {
      this.loading = true
      await Promise.all([
        this.$store.dispatch('getProducts'),
        this.$store.dispatch('getWarehouses'),
        this.$store.dispatch('getRecipe', {
          id: this.$route.query.id,
        }),
      ])
      this.setDefaultValies()
      this.loading = false
      this.showFinish(this.$Progress)
    },
    setDefaultValies() {
      this.defaultValues = {
        recipe: this.recipe,
      }
    },
    getFormData (form = {}) {
      return {
        'name': form.name,
        'stock_skus': form.stockSkus.map((stockSkuItem) => {
          return {
            'sku_id': stockSkuItem.location_data.sku_id,
            'wh_id': stockSkuItem.location_data.wh_id,
            'stock_id': stockSkuItem.location_data.stock_id,
            'bin_location_id': stockSkuItem.location_data.bin_location_id,
            'required_unit': Number(stockSkuItem.required_unit),
          }
        }),
        'assign_skus': form.assignSkus.map((assignSkuItem) => {
          return {
            'sku_id': assignSkuItem.value,
          }
        }),
      }
    },
    async handleSubmit (form = {}) {
      this.isSubmitted = true
      this.disabled = true
      const data = this.getFormData(form)
      const response = await this.$store.dispatch('updateRecipe', {
        id: this.recipe._id,
        data,
      })
      if (response.success) {
        this.isSubmitted = false
        this.disabled = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: form.name }),
          color: 'success',
          icon: 'cloud',
        })
        this.showFinish(this.$Progress)
      }
    },
    handleSelectOption (value) {
      if (value === 'delete') {
        this.onOpenModal()
      }
    },
    onOpenModal () {
      this.modal.show = true
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal () {
      this.modal.loading = true
      const response = await this.$store.dispatch('deleteRecipe', {
        id: this.recipe._id,
      })
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.recipe.name }),
          color: 'danger',
          icon: 'delete',
        })
        this.modal.loading = false
        this.modal.show = false
        this.$router.push({ name: 'RecipeAll' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/items/recipe/Edit.vue